export default "__VITE_ASSET__B239h5_s__"